<template>
  <div ref="containerRef" />
</template>

<script setup>
import lottie from 'lottie-web/build/player/esm/lottie_light.min.js'
import { onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  jsonConfigPath: {
    type: String,
    default: '',
  },
  loop: {
    type: Boolean,
    default: true,
  },
  autoplay: {
    type: Boolean,
    default: true,
  },
})

const containerRef = ref(null)
const lottieAnimationObject = ref(null)

onMounted(() => {
  lottieAnimationObject.value = lottie.loadAnimation({
    container: containerRef.value,
    path: props.jsonConfigPath,
    renderer: 'svg',
    loop: props.loop,
    autoplay: props.autoplay,
  })
})

onBeforeUnmount(() => {
  if (lottieAnimationObject.value != null) {
    lottieAnimationObject.value.destroy()
    lottieAnimationObject.value = null
  }
})
</script>
